import * as actionTypes from '../actions/actionTypes';

const initialState = {
  charityActivity: {
    charityActivity: [],
    count: "",
    isLoading: false,
    isError: false
  },
  recentCharityActivity:  null,
  charityDetails: [{}],
  galleryDetails:[{}],
  deletedCharity: {},
  deleteCharityActivity: {},
  bunitFilterList: {},
  createdCharityData: {},
  updatedCharityData: {},
  uploadFilesData: null,
  isLoading: false,
  isError: false,
}

const charityActivityReducer = (state = initialState, action = {}) => {

  const newState = { ...state };

  switch (action.type) {
    case actionTypes.FETCH_CHARITY_ACTIVITY_DETAILS:
      return { ...newState, isLoading: true };

    case actionTypes.FETCH_CHARITY_ACTIVITY_DETAILS_SUCCESS:
      return { ...newState, isLoading: false, charityDetails: { ...action.payload } };

    case actionTypes.FETCH_CHARITY_ACTIVITY_DETAILS_FAILURE:
      return { ...newState, isLoading: false, charityDetails: { ...action.payload }, isError: true };

    case actionTypes.FETCH_CHARITY_ACTIVITY_LIST:
      return { ...newState, charityActivity: { ...newState.charityActivity, isLoading: true } };

    case actionTypes.FETCH_CHARITY_ACTIVITY_LIST_SUCCESS:
      return { ...newState, charityActivity: { charityActivity: [...action.payload.data], count: action.payload.totalCount, isLoading: false, isError: false }, createdCharityData: {}, updatedCharityData: {},deletedCharity: {} };

    case actionTypes.FETCH_CHARITY_ACTIVITY_LIST_FAILURE:
      return { ...newState, charityActivity: {...action.payload}, count: action.payload.totalCount, isLoading: false, isError: true  };

    case actionTypes.FETCH_RECENT_CHARITY_ACTIVITY_LIST:
      return { ...newState, recentCharityActivity: { ...newState.charityActivity, isLoading: true } };

    case actionTypes.FETCH_RECENT_CHARITY_ACTIVITY_LIST_SUCCESS:
      return { ...newState, recentCharityActivity: { ...action.payload }, isError: false };

    case actionTypes.FETCH_RECENT_CHARITY_ACTIVITY_LIST_FAILURE:
      return { ...newState, recentCharityActivity: {...action.payload} , isError: true };

    case actionTypes.FETCH_CHARITY_ACTIVITY_FILTER_LIST:
      return { ...newState, isLoading: true };

    case actionTypes.FETCH_CHARITY_ACTIVITY_FILTER_LIST_SUCCESS:
      return { ...newState, isLoading: false, bunitFilterList: { ...action.payload } };

    case actionTypes.FETCH_CHARITY_ACTIVITY_FILTER_LIST_FAILURE:
      return { ...newState, isLoading: false, isError: true, bunitFilterList: { ...action.payload }  };

      case actionTypes.CREATE_CHARITY_ACTIVITY:
      return { ...newState, isLoading: true };

    case actionTypes.CREATE_CHARITY_ACTIVITY_SUCCESS:
      return { ...newState, isLoading: false, createdCharityData: { ...action.payload } };

    case actionTypes.CREATE_CHARITY_ACTIVITY_FAILURE:
      return { ...newState, isLoading: false, isError: true, createdCharityData: { ...action.payload } };

    case actionTypes.UPDATE_CHARITY_ACTIVITY:
    return { ...newState, isLoading: true };

    case actionTypes.UPDATE_CHARITY_ACTIVITY_SUCCESS:
      return { ...newState, isLoading: false, updatedCharityData: { ...action.payload } };

    case actionTypes.UPDATE_CHARITY_ACTIVITY_FAILURE:
      return { ...newState, isLoading: false, isError: true, updatedCharityData: { ...action.payload } };

    case actionTypes.DELETE_CHARITY_ACTIVITY:
        return {...newState , isLoading: true, deletedCharity:{}};
          
    case actionTypes.DELETE_CHARITY_ACTIVITY_SUCCESS:
        return {...newState , isLoading: false, isError:false, deletedCharity:{...action.payload}, errorMessage: {}};
  
    case actionTypes.DELETE_CHARITY_ACTIVITY_FAILURE:
        return {...newState , isLoading: false, isError:true, errorMessage: {...action.payload}, deleteUser: {} };
    case actionTypes.UPLOAD_FILES:
        return {...newState , isLoading: true, uploadFilesData:{}};
          
    case actionTypes.UPLOAD_FILES_SUCCESS:
        return {...newState , isLoading: false, isError:false, uploadFilesData:{...action.payload}, errorMessage: {}};
  
    case actionTypes.UPLOAD_FILES_FAILURE:
        return {...newState , isLoading: false, isError:true, errorMessage: {...action.payload}, deleteUser: {} };

    case actionTypes.FETCH_GALLERY_DETAILS:
      return { ...newState, isLoading: true };

    case actionTypes.FETCH_GALLERY_DETAILS_SUCCESS:
      return { ...newState, isLoading: false, galleryDetails: { ...action.payload } };

    case actionTypes.FETCH_GALLERY_DETAILS_FAILURE:
      return { ...newState, isLoading: false, galleryDetails: { ...action.payload }, isError: true }; 

    default:
      return { ...newState };
  }
};


export default charityActivityReducer;